import React, { useEffect, useState, useRef } from "react";
import "./style.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ReactPaginate from "react-paginate";
import { useSelector, useDispatch } from 'react-redux';
import Xicon from "../assets/Delete Icon.svg";
import { fetchData } from '../redux/apiSlice';
import { format } from 'date-fns';
import {
  toastify,
  userlogout,
  clearuser,
  dateToMDY,
} from "../redux/controller";

export default function UpcomingReservationsid() {
  const dispatch = useDispatch()
  const initialized = useRef(false)
  const usertoken = useSelector((state) => state.userdata.usertoken);
  const search = useLocation().search;
  const queryParams = new URLSearchParams(search);
  const userid = queryParams.get("user");
  const isDialogVisibleParam = queryParams.get("isDialogVisible");
  const reservationIdParam = queryParams.get("reservationId") || queryParams.get("reservationid") || queryParams.get("id");

  const [userdetail, setuserdetail] = useState({});
  const [userdetailreservations, setuserdetailreservations] = useState([]);
  const [showCancelLoader, setCancelLoader] = useState(false);
  const [isDialogVisible, setIsDialogVisible] = useState(
    isDialogVisibleParam?.toLowerCase() === "true" || isDialogVisibleParam === "1"
  );


  let Navigate = useNavigate();
  const [step1inputField, setstep1InputField] = useState({
    cancelreason: "",
  });


  const [cancelreservation, setcancelreservation] = useState({});

  const hasAutoOpened = useRef(false);
  const prevParamRef = useRef(reservationIdParam + "_" + isDialogVisibleParam);

  useEffect(() => {
    const currentKey = reservationIdParam + "_" + isDialogVisibleParam;
    if (prevParamRef.current !== currentKey) {
      prevParamRef.current = currentKey;
      hasAutoOpened.current = false;
    }
  }, [reservationIdParam, isDialogVisibleParam]);

  useEffect(() => {
    const isParamTrue = isDialogVisibleParam?.toLowerCase() === "true" || isDialogVisibleParam === "1";
    if (
      !hasAutoOpened.current &&
      isParamTrue &&
      userdetailreservations &&
      userdetailreservations.length > 0
    ) {
      hasAutoOpened.current = true;
      const found = reservationIdParam
        ? userdetailreservations.find(
            (r) =>
              String(r._id) === String(reservationIdParam) ||
              String(r.id) === String(reservationIdParam) ||
              String(r.reservationid) === String(reservationIdParam)
          ) || userdetailreservations[0]
        : userdetailreservations[0];
      if (found) {
        setcancelreservation(found);
        setIsDialogVisible(true);
      }
    }
  }, [userdetailreservations, isDialogVisibleParam, reservationIdParam]);

  function openCancelDialog(reservation) {
    setcancelreservation(reservation);
    setIsDialogVisible(true);
  }

  function handlepopupclose() {
    setcancelreservation({});
    setIsDialogVisible(false);
  }



  const inputsHandler = (e) => {
    console.log(e.target.name);
    setstep1InputField((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  async function handlecancelreservation() {
    const reservationToCancel = cancelreservation;
    setcancelreservation({});
    setIsDialogVisible(false);
    setCancelLoader(true);
    var cancelledreservation = await dispatch(
      fetchData({
        apiurl: "/reservation/cancel",
        reservationid: reservationToCancel._id,
        cancellationReasonLandowner: step1inputField.cancelreason,
        headers: { "x-access-token": usertoken },
      })
    );
    console.log(cancelledreservation);
    setCancelLoader(false);
    setstep1InputField((prevState) => ({
      ...prevState,
      ["cancelreason"]: "",
    }));
    if (
      cancelledreservation &&
      cancelledreservation.payload &&
      cancelledreservation.payload.status == 200
    ) {
      if (
        reservationToCancel &&
        reservationToCancel.userid &&
        reservationToCancel.userid.udid &&
        reservationToCancel.cart &&
        reservationToCancel.cart[0]
      ) {
        var cancelledreservationnotification = await dispatch(
          fetchData({
            apiurl: "/reservation/send/notification",
            messagingtoken: reservationToCancel.userid.udid,
            title: "Landowner cancelled your reservation",
            message:
              reservationToCancel.cart[0].property.title +
              " : " +
              step1inputField.cancelreason,
            propertyname: reservationToCancel.cart[0].property.title,
            headers: { "x-access-token": usertoken },
          })
        );
      }

      getuserdetail()
    } else {
      console.log(cancelledreservation.payload);
      if (cancelledreservation.payload.response && cancelledreservation.payload.response.data && cancelledreservation.payload.response.data.message
      ) {
        // toastify({
        //   message: cancelledreservation.payload.response.data.message,
        // });
        if (
          cancelledreservation.payload.response.data.message == "Invalid token provided!" || cancelledreservation.payload.response.data.message == "No token provided!"
        ) {
          clearuser();
          userlogout();
          Navigate("/");
          window.location.reload();
        }
      } else if (
        cancelledreservation.payload &&
        cancelledreservation.payload.message
      ) {
        toastify({ message: cancelledreservation.payload.message });
      }
      return null;
    }
  }

  function handleCancelclick() {
    setcancelreservation({});
  }




  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true
      if (userid) {
        getuserdetail()
      }
    }
  }, []);

  async function getuserdetail() {

    var userdetail = await dispatch(
      fetchData({
        apiurl: "/auth/user/detail",
        fetchid: userid,
        headers: { "x-access-token": usertoken }
      })
    );

    if (userdetail && userdetail.payload && userdetail.payload.status === 200) {
      setuserdetail(userdetail.payload.data);

      if (userdetail.payload.data.reservations && userdetail.payload.data.reservations.length) {
        // Create a shallow copy of the reservations array before sorting
        var reservation = [...userdetail.payload.data.reservations];

        reservation.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());

        setuserdetailreservations(reservation);
      }
    }
    else {
      if (userdetail.payload && userdetail.payload.message) {
        toastify({ message: userdetail.payload.message })
      }
    }
  }

  function convertdate(date) {
    return date.substring(6, 8) + "/" + date.substring(9, 11) + "/" + date.substring(1, 5)
  }

  function inputhistoryperPage(e) {
    setreservationupcomingidperPage(e.target.value)
    setReservationupcomingidcurrentPage(1);
  }

  const handlereservationupcomingidPageClick = (selectedPage) => {
    setReservationupcomingidcurrentPage(selectedPage.selected + 1);
  };

  // Calculate start and end index for the current page
  const [
    reservationupcomingidcurrentPage,
    setReservationupcomingidcurrentPage
  ] = useState(1);
  const [
    reservationupcomingidperPage,
    setreservationupcomingidperPage
  ] = useState(10);
  // const reservationupcomingidperPage = 10;
  const reservationupcomingidstartIndex =
    reservationupcomingidcurrentPage * reservationupcomingidperPage;
  const reservationupcomingidendIndex =
    reservationupcomingidstartIndex + reservationupcomingidperPage;

  // Get data for the current page
  const reservationupcomingidcurrentData = userdetailreservations ? userdetailreservations : []
  // const reservationupcomingidcurrentData = userdetail && userdetail.reservations ? userdetail.reservations.slice(
  //   reservationupcomingidstartIndex,
  //   reservationupcomingidendIndex
  // ).sort((a,b)=>new Date(b.createdAt).getTime()-new Date(a.createdAt).getTime())  :[];
  return (
    <>
      {userdetail && userdetail.user ? <div>
        <div className="reservation-idtable">
          <div className="reservation_divider">
            <div className="reservation_part">
              <div className="reservation_content">
                <h1>Name</h1>
                <p>{userdetail.user.firstname} {userdetail.user.lastname}</p>
              </div>
            </div>
            <div className="reservation_part">
              <div className="reservation_content">
                <h1>Email ID</h1>
                <p>{userdetail.user.email}</p>
              </div>
            </div>
            <div className="reservation_part">
              <div className="reservation_content">
                <h1>Phone Number</h1>
                <p>{userdetail.user.phonenumber}</p>
              </div>
            </div>
            <div className="reservation_part">
              <div className="reservation_content">
                <h1>Account Created</h1>
                <p>{convertdate(JSON.stringify(userdetail.user.createdAt))}</p>
              </div>
            </div>
          </div>
          <div className="add-form pagination-table">
            <div className="add-table">
              <table className="table">
                <thead>
                  <tr>
                    <th>Property Name</th>
                    <th>Slot ID</th>
                    <th>Reservation Date</th>
                    <th>Cost</th>
                    <th>Coupon Used</th>
                    <th>Payment ID</th>
                    <th>Reservation Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {userdetailreservations ? userdetailreservations.map((reservation, index) => (
                    index < reservationupcomingidperPage * reservationupcomingidcurrentPage && index >= reservationupcomingidperPage * (reservationupcomingidcurrentPage - 1) ?
                      <tr key={reservation._id} className={
                        reservation.orderstatus.toLowerCase() === "cancelled"
                          ? "history_cancelled"
                          : reservation.orderstatus.toLowerCase() === "pending"
                            ? "history_pending" : reservation.orderstatus.toLowerCase() === "completed"
                              ? "history_completed"
                              : reservation.orderstatus.toLowerCase() === "booked" && reservation.isrequestedforcanceling ?
                                "upcoming_pending_cancel" : "history_booked"}>
                        <td>
                          <Link className="pro-link" to={"/propertydetails?index=" + reservation._id}>
                            {reservation.cart[0].property.title}
                          </Link>
                        </td>
                        <td>{reservation.cart.map((name) => (<p>{name.selectedslot.name}</p>))}</td>
                        <td>{reservation.cart.map((name) => (<p>{name.selecteddate ? convertdate(JSON.stringify(name.selecteddate)) : '--'}</p>))}</td>
                        <td>{reservation.paymentdetail ? `$${reservation.paymentdetail.total}` : '--'}</td>
                        <td>{reservation.couponapplied && reservation.couponapplied.couponcode ? reservation.couponapplied.couponcode : userdetail.user.subscriptions && userdetail.user.subscriptions.length && userdetail.user.subscriptions[0].no_of_memberships ? "Membership" : "--"}</td>
                        <td>{reservation.payment && reservation.payment.paymentdata && reservation.payment.paymentdata.paymenttId ? reservation.payment.paymentdata.paymenttId : '--'}</td>

                        {/* <td>
                          <button className="reservation-actionbtn">
                            <i className={reservation.orderstatus.toUpperCase() == "BOOKED" ? "fa-solid fa-circle-check" : reservation.orderstatus.toUpperCase() == "PENDING" ? "fa-regular fa-clock" : "fa-solid fa-circle-xmark"}></i>
                            {reservation.orderstatus.toUpperCase()}
                          </button>
                        </td> */}

                        <td>
                          <button
                            className="reservation-actionbtn"
                            onClick={() =>
                              reservation.orderstatus.toLowerCase() === "cancel" && handleCancelclick()
                            }>
                            <i
                              className={reservation.orderstatus.toUpperCase() == "PENDING" || (reservation.orderstatus.toUpperCase() == 'BOOKED' && reservation.isrequestedforcanceling)
                                ? "fa-regular fa-clock"
                                : reservation.orderstatus.toUpperCase() == "BOOKED"
                                  ? "fa-solid fa-circle-check"
                                  : "fa-solid fa-circle-xmark"
                              }
                            ></i>
                            {(reservation.orderstatus.toUpperCase() == 'BOOKED' && reservation.isrequestedforcanceling) ? 'CANCELLATION REQUESTED' : reservation.orderstatus.toUpperCase()}
                          </button>
                        </td>

                        {(() => {
                          const today = new Date();
                          today.setHours(0, 0, 0, 0); // Normalize today's date
                          let hasPastDate = false;
                          for (const item of reservation.cart) {

                            if (item.selecteddate) {
                              const selected = new Date(item.selecteddate);
                              selected.setHours(0, 0, 0, 0);

                              if (selected < today) {
                                console.log("Checking for index is true", index);
                                hasPastDate = true;
                                break;
                              } else {
                                console.log("Checking for index is false", index);
                              }
                            }
                          }


                          return (
                            <td>
                              {reservation.orderstatus !== 'cancelled' ? (
                                <button
                                  className="reservation-actionbtns"
                                  id={'cancellationreason_' + reservation._id}
                                  onClick={() => openCancelDialog(reservation)}
                                  disabled={hasPastDate}
                                >
                                  <i className="fa-solid fa-circle-xmark"></i>
                                  CANCEL
                                </button>
                              ) : (
                                <button className="reservation-actionbtns" disabled>
                                  <i className="fa-solid fa-circle-xmark"></i>
                                  CANCELLED
                                </button>
                              )}
                            </td>
                          );
                        })()}



                      </tr> : ""
                  )) : ""}
                </tbody>
              </table>
            </div>
            <div className="rowperpage">
              <div className="perpagecount">
                Row Per Page&nbsp;
                <select
                  onChange={inputhistoryperPage}
                  value={reservationupcomingidperPage}>
                  <option value={10}>10</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                  <option value={150}>150</option>
                  <option value={200}>200</option>
                </select>
              </div>
              <ReactPaginate
                pageCount={Math.ceil(
                  userdetailreservations.length / reservationupcomingidperPage
                )}
                pageRangeDisplayed={reservationupcomingidperPage}
                breakLabel={"..."}
                marginPagesDisplayed={2}
                onPageChange={handlereservationupcomingidPageClick}
                containerClassName={"pagination custom-pagination"}
                activeClassName={"active"}
              />
            </div>
          </div>
        </div>
      </div> : <div className="loader spacing-top"></div>}


      {(() => {
        const isCancelled = cancelreservation && cancelreservation.orderstatus && (
          cancelreservation.orderstatus.toLowerCase() === "cancelled" ||
          cancelreservation.orderstatus.toLowerCase() === "cancel"
        );
        const cancellationReasonText = cancelreservation ? (
          cancelreservation.cancellationReasonLandowner ||
          cancelreservation.cancellation_reason ||
          cancelreservation.cancelreason ||
          (cancelreservation.cart && cancelreservation.cart.map((item) => item.cancellationReasonLandowner).filter(Boolean).join(", ")) ||
          "--"
        ) : "--";

        return (
          (isDialogVisible || (cancelreservation && cancelreservation._id)) && cancelreservation && cancelreservation._id && (
            <div className="managecou-popup">
              <div className="managecou-content res-delete">
                <i className="fa-solid fa-xmark" onClick={handlepopupclose}></i>
                <div className="managecou-contentdiv">
                  <img src={Xicon} alt="Xicon" />
                  <h1>{isCancelled ? "Reservation Cancelled" : "Are you Sure?"}</h1>
                  <p>
                    {isCancelled
                      ? "This reservation has already been cancelled."
                      : "Are you sure you want to cancel the reservation."}
                  </p>

                  <div className="cancel-res-details">
                    <h3>Reservation Details</h3>
                    <div className="cancel-res-details-grid">
                      <div className="detail-item">
                        <span className="detail-label">Property Name:</span>
                        <span className="detail-value">
                          {cancelreservation.cart && cancelreservation.cart[0] && cancelreservation.cart[0].property
                            ? cancelreservation.cart[0].property.title
                            : "--"}
                        </span>
                      </div>
                      <div className="detail-item">
                        <span className="detail-label">Slot ID:</span>
                        <span className="detail-value">
                          {cancelreservation.cart
                            ? cancelreservation.cart.map((name) => (name.selectedslot ? name.selectedslot.name : "")).filter(Boolean).join(", ")
                            : "--"}
                        </span>
                      </div>
                      <div className="detail-item">
                        <span className="detail-label">Reservation Date:</span>
                        <span className="detail-value">
                          {cancelreservation.cart
                            ? cancelreservation.cart.map((name) => (name.selecteddate ? convertdate(JSON.stringify(name.selecteddate)) : "--")).filter(Boolean).join(", ")
                            : "--"}
                        </span>
                      </div>
                      <div className="detail-item">
                        <span className="detail-label">Cost:</span>
                        <span className="detail-value">
                          {cancelreservation.paymentdetail ? `$${cancelreservation.paymentdetail.total}` : "--"}
                        </span>
                      </div>
                      <div className="detail-item">
                        <span className="detail-label">Coupon Used:</span>
                        <span className="detail-value">
                          {cancelreservation.couponapplied && cancelreservation.couponapplied.couponcode
                            ? cancelreservation.couponapplied.couponcode
                            : userdetail && userdetail.user && userdetail.user.subscriptions && userdetail.user.subscriptions.length && userdetail.user.subscriptions[0].no_of_memberships
                            ? "Membership"
                            : "--"}
                        </span>
                      </div>
                      <div className="detail-item">
                        <span className="detail-label">Payment ID:</span>
                        <span className="detail-value">
                          {cancelreservation.payment && cancelreservation.payment.paymentdata && cancelreservation.payment.paymentdata.paymenttId
                            ? cancelreservation.payment.paymentdata.paymenttId
                            : "--"}
                        </span>
                      </div>
                      <div className="detail-item">
                        <span className="detail-label">Status:</span>
                        <span className="detail-value">
                          {cancelreservation.orderstatus ? cancelreservation.orderstatus.toUpperCase() : "--"}
                        </span>
                      </div>
                      {isCancelled && (
                        <div className="detail-item full-width">
                          <span className="detail-label">Cancellation Reason:</span>
                          <span className="detail-value">{cancellationReasonText}</span>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="form-floating">
                    <textarea
                      className="form-control"
                      placeholder="Leave a comment here"
                      id="floatingTextarea2"
                      name="cancelreason"
                      onChange={inputsHandler}
                      value={isCancelled ? cancellationReasonText : step1inputField.cancelreason}
                      disabled={isCancelled}
                      readOnly={isCancelled}
                    ></textarea>
                    <label htmlFor="floatingTextarea2">{isCancelled ? "Cancellation Reason" : "Reason..."}</label>
                  </div>
                </div>
                <div className="managecou-btn">
                  <button className="btn1" onClick={handlepopupclose} disabled={isCancelled}>
                    No
                  </button>
                  <button className="btn2" onClick={handlecancelreservation} disabled={isCancelled}>
                    Yes
                  </button>
                </div>
              </div>
            </div>
          )
        );
      })()}

      {showCancelLoader ? (
        <div className="loader_section">
          <div className="res_loader">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
}
